import times from 'lodash/times'
import { z } from 'zod'

import type { SelectOptionsType } from '@/components/ui/form/FormSelect'

import type { NewMessageUserFiltersFormValues } from './UsersListFilters'

const filterWithValue = z.object({
  isActive: z.boolean().optional(),
})

export const schema = z.object({
  total_spent: filterWithValue.extend({ value: z.number() }),
  tips: filterWithValue.extend({ value: z.number() }),
  duration: filterWithValue.extend({ value: z.number() }),
  inactive: filterWithValue.extend({ value: z.number() }),
  recommenders: filterWithValue.extend({ value: z.boolean().optional() }),
  online: filterWithValue.extend({ value: z.boolean().optional() }),
  signed_up_after: filterWithValue.extend({ value: z.string().optional() }),
  signed_up_before: filterWithValue.extend({ value: z.string().optional() }),
})

const increment = (num: number) => num + 1

// From 100 to 20.000
const totalSpentOptionValues = [
  ...times(9, (index) => increment(index) * 100),
  ...times(10, (index) => increment(index) * 1000),
]
// From 10 to 100
const tipsOptionValues = times(10, (index) => increment(index) * 10)
// From 1 to 12
const subscribedOverOptionValues = times(12, increment)
// From 1 to 30
const inactiveOptionValues = times(30, increment)

export const totalSpentOptions = totalSpentOptionValues.map((value) => ({
  value: String(value),
  label: `$ ${value}`,
}))
export const tipsOptions = tipsOptionValues.map((value) => ({
  value: String(value),
  label: `$ ${value}`,
}))
export const durationOptions = subscribedOverOptionValues.map((value) => ({
  value: String(value),
  label: `${value} ${value === 1 ? 'month' : 'months'}`,
}))
export const inactiveOptions = inactiveOptionValues.map((value) => ({
  value: String(value),
  label: `${value} ${value === 1 ? 'day' : 'days'}`,
}))

export const defaultValues: NewMessageUserFiltersFormValues = {
  total_spent: { value: +totalSpentOptions[0].value, isActive: false },
  tips: { value: +tipsOptions[0].value, isActive: false },
  duration: { value: +durationOptions[0].value, isActive: false },
  inactive: { value: +inactiveOptions[0].value, isActive: false },
  recommenders: { value: true, isActive: false },
  online: { value: true, isActive: false },
  signed_up_after: { value: '', isActive: false },
  signed_up_before: { value: '', isActive: false },
}

export const fieldsWithControls: {
  title: string
  name: keyof Pick<
    NewMessageUserFiltersFormValues,
    'total_spent' | 'tips' | 'duration' | 'inactive'
  >
  options: SelectOptionsType
}[] = [
  { title: 'Total spent', name: 'total_spent', options: totalSpentOptions },
  { title: 'Tipped over', name: 'tips', options: tipsOptions },
  {
    title: 'Subscriber over',
    name: 'duration',
    options: durationOptions,
  },
  { title: 'Expired over', name: 'inactive', options: inactiveOptions },
]

export const USERS_FILTER_FORM_ID = 'users-filter-form'
